@use "variables" as *;

.title {
  text-align: center;
  font-weight: bold;
  font-size: $fontSize-xs;
}

.chart {
  width: $bar-chart-size;
  height: $bar-chart-size;
  font-size: $fontSize-xs;
}
